angular.module('impactx.timeline').controller('TimelineCtrl', ['$scope', '$redirect', 'TranslationService', TimelineCtrl]);

function TimelineCtrl($scope, $redirect, TranslationService) {
    $scope.goToDetailPage = function (timelineEntry) {
        if (timelineEntry.allowDetailDialog.value && !$scope.noLinks) {
            var url = timelineEntry.route + timelineEntry.id;
            $redirect.redirectTo(null, url)
        }
    };

    $scope.hasDeliveryNoteAction = function () {
        return $scope.deliveryNoteActionFunction && angular.isFunction($scope.deliveryNoteActionFunction);
    };

    $scope.callDeliveryNoteAction = function (event, dnhId) {
        $scope.deliveryNoteActionFunction({event: event, dnhId: dnhId});
    };

    $scope.orderNumberPrefix = TranslationService.get("orderNumberPrefix");
    $scope.orderRefPrefix = TranslationService.get("orderRefPrefix");
}